export const NEW_JOB_APPLICATION_COMPANY_NOTIFICATION = "NewJobApplicationCompanyNotification";
export type NEW_JOB_APPLICATION_COMPANY_NOTIFICATION_TYPE = "NewJobApplicationCompanyNotification";
export const APPROVED_OFFER_COMPANY_NOTIFICATION = "ApprovedOfferCompanyNotification";
export type APPROVED_OFFER_COMPANY_NOTIFICATION_TYPE = "ApprovedOfferCompanyNotification";
export const REJECTED_OFFER_COMPANY_NOTIFICATION = "RejectedOfferCompanyNotification";
export type REJECTED_OFFER_COMPANY_NOTIFICATION_TYPE = "RejectedOfferCompanyNotification";
export const APPROVED_PROFILE_COMPANY_NOTIFICATION = "ApprovedProfileCompanyNotification";
export type APPROVED_PROFILE_COMPANY_NOTIFICATION_TYPE = "ApprovedProfileCompanyNotification";
export const REJECTED_PROFILE_COMPANY_NOTIFICATION = "RejectedProfileCompanyNotification";
export type REJECTED_PROFILE_COMPANY_NOTIFICATION_TYPE = "RejectedProfileCompanyNotification";
